module.exports = __webpack_public_path__ + "static/L2_visual_2_3_eg-8aed85d4fd82703ef5733815ba6bf7c7.png";